import { render } from "./businessreport.vue?vue&type=template&id=4221943e&scoped=true"
import script from "./businessreport.vue?vue&type=script&lang=js"
export * from "./businessreport.vue?vue&type=script&lang=js"

import "./businessreport.vue?vue&type=style&index=0&id=4221943e&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4221943e"]])

export default __exports__